/* eslint-disable eqeqeq */
import moment from 'moment';
import { DATE_FORMAT_ISO } from 'constants/general';
import { ROLES_OBJECT } from 'constants/onBoarding';
import { KEY_CALENDAR_TOKEN } from '../views/CalendarView/constants';
import { LOCAL_USER_TYPE } from 'constants/localStorage';
import { mergeDeepRight } from 'ramda';
import { format, parseISO } from 'date-fns';

export const isTeacher = () => LOCAL_USER_TYPE() === ROLES_OBJECT.TEACHER.value;

export const isRoleType = (rols: string[] = []) => {
  let valid = false;
  rols.map((rol: any) => {
    if (rol && LOCAL_USER_TYPE() === ROLES_OBJECT[rol?.toUpperCase()]?.value) valid = true;
    return rol;
  });
  return valid;
};

export const getRelationship = (id: any) => {
  let relation;

  switch (id) {
    case 1:
      relation = 'FAMILY_ROLE_MOM';
      break;
    case 2:
      relation = 'FAMILY_ROLE_DAD';
      break;
    case 3:
      relation = 'FAMILY_ROLE_NANNY';
      break;
    case 4:
      relation = 'FAMILY_ROLE_GRANDMA';
      break;
    case 5:
      relation = 'FAMILY_ROLE_GRANDPA';
      break;
    case 6:
      relation = 'FAMILY_ROLE_AUNTIE';
      break;
    case 7:
      relation = 'FAMILY_ROLE_UNCLE';
      break;
    case 8:
      relation = 'FAMILY_ROLE_GUEST';
      break;
    default:
      relation = 'FAMILY_ROLE_GUEST';
      break;
  }
  return relation;
};

export const getLocalStorageItem = (key: string) =>
  localStorage.getItem(key);

export const getWeeksDays = ({
  date = moment().format(),
  from = 0,
  days = 7,
} = {}) => {
  const currentDate = moment(date).clone().startOf('isoWeek');
  const calculateDay = (fromDate: any) => {
    const result = [];
    for (let i = 0; i <= 12; i++) {
      result.push({
        label: moment(fromDate).add(i, 'days').format('dddd'),
        value: moment(fromDate).add(i, 'days').format(),
        day: moment(fromDate).add(i, 'days').format('DD'),
        number: i + 1,
      });
    }
    return result;
  };

  const currentDays = calculateDay(currentDate);
  const upcomingDays = calculateDay(moment([...currentDays].pop()?.value).add(1, 'days').clone().startOf('isoWeek'));
  const lastDays = calculateDay(moment(currentDays[0].value).subtract(1, 'd').clone().startOf('isoWeek'));
  const lastDaysSlice = lastDays.slice(from, days);
  const currentDaysSlice = currentDays.slice(from, days).map((day: any, index) => ({
    ...day,
    position: index + 1,
  }));
  const upcomingDaysSlice = upcomingDays.slice(from, days).map((day: any, index) => ({
    ...day,
    position: index + 1,
  }));

  return {
    last: {
      name: 'Last',
      days: lastDaysSlice,
      range: `${moment(lastDaysSlice[0]?.value).format('MMM DD')} - ${moment([...lastDaysSlice].pop()?.value).format('MMM DD')}`,
    },
    current: {
      name: 'Current',
      days: currentDaysSlice,
      range: `${moment(currentDaysSlice?.slice(from, days)[0]?.value).format('MMM DD')} - ${moment([...currentDaysSlice?.slice(from, days)].pop()?.value).format('MMM DD')}`,
    },
    upcoming: {
      name: 'Upcoming',
      days: upcomingDaysSlice,
      range: `${moment(upcomingDaysSlice[0]?.value).format('MMM DD')} - ${moment([...upcomingDaysSlice].pop()?.value).format('MMM DD')}`,
    },
  };
};

export const prepareUserParams = (params: any) => {
  if (!localStorage.getItem(KEY_CALENDAR_TOKEN)) {
    params = {
      ...params,
      [KEY_CALENDAR_TOKEN]: 1,
    };
  } else if (window?.KineduCalendarApi?.setOptions) {
    window.KineduCalendarApi.setOptions({
      access_token: localStorage.getItem(KEY_CALENDAR_TOKEN),
    });
  }
  return params;
};

export const USER_PARAMS = prepareUserParams({
  // active_center_id: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_ID),
});

export const handleUserResultForCalendarSettings = ({ calendar_api: calendarApi }: any) => {
  if (calendarApi?.access_token) {
    localStorage.setItem(KEY_CALENDAR_TOKEN, calendarApi.access_token);
  }
};

export const findItemById = (list: any = [], id?: number) =>
  list?.find((item: any) => item?.id == id);

export const setLocalStorageItem = (name: string, item: any) => {
  localStorage.setItem(name, String(item));
};

export const actionByRole = (
  roleType: string,
  actions?: any,
) => {
  const {
    owner: ownerAction,
    admin: adminAction,
    director: directorAction,
    teacher: teacherAction,
  } = actions;
  switch (roleType) {
    case 'Owner': if (ownerAction) return ownerAction(); break;
    case 'Admin': if (adminAction) return adminAction(); break;
    case 'Director': if (directorAction) return directorAction(); break;
    case 'Teacher': if (teacherAction) return teacherAction(); break;
    default: throw Error('NO_ROLE_TYPE_PROVIDED');
  }
};


export const mergeDeepRightMap = (list: any[], itemToMerge: any, keyToMatch: any) =>
  list.map((item: any) => {
    if (item.id === itemToMerge[keyToMatch]) return mergeDeepRight(item, itemToMerge);
    return item;
  });

export const parseDateAdjusted = (stringDate: string) => {
  const parsedDate = parseISO(stringDate);
  const adjustedDate = new Date(parsedDate.valueOf() + parsedDate.getTimezoneOffset() * 60 * 1000);
  return adjustedDate;
};

export const parseAdjustAndFormatDate = (date: any) =>
  format(parseDateAdjusted(date), DATE_FORMAT_ISO);

export function loadScript(src: string) {
  // create a promise for the loadScript
  return new Promise((resolve, reject) => {
    // create an html script element
    const script = document.createElement('script');
    // set the source of the script element
    script.src = src;
    // set a listener when the script element finishes loading the script
    script.addEventListener('load', () => {
      // resolve if the script element loads
      resolve();
    });
    // set a listener when the script element faces any errors while loading
    script.addEventListener('error', (e) => {
      // reject if the script element has an error while loading the script
      reject(e);
    });
    // append the script element to the body
    document.body.appendChild(script);
  });
}

export const only = (obj: Record<string, any>, keys: string[], fallback?: any) => {
  let newObjectValues: Record<string, any> = {};

  keys.forEach((key: string) => {
    if (obj.hasOwnProperty(key)) {
      newObjectValues[key] = obj[key] === null ? fallback || '' : obj[key];
    }
  });

  return newObjectValues;
};

export const except = (obj: Record<string, any>, keys: string[]) => {
  let newObjectValues: Record<string, any> = {};

  Object.keys(obj).forEach((key: string) => {
    if (!keys.includes(key)) {
      newObjectValues[key] = obj[key];
    }
  });

  return newObjectValues;
};

/**
 * Return the author's full name
 *
 * @param author Object
 * @param fallback string
 *
 * @return string | null
 */
export const getActivityAuthor = (author: Record<string, string | number>, fallback: string = '') => {
  if (author) {
    const firstName = author.name || '';
    const lastName = author.lastname || author.last_name || '';

    return `${firstName} ${lastName}`;
  }

  return fallback || null;
}

export const s3AvatarsPath = (prefix: string) => `/${prefix}/avatars/`;

export const prepareFilename = (filename: string, id: string) => {
  const fileSubstrings = filename.split('.');
  const extension = fileSubstrings[fileSubstrings.length - 1];

  return `${Date.now()}_${id}_file.${extension}`;
}
